import { render } from "./PaymentMethodModal.vue?vue&type=template&id=ba7cdc82"
import script from "./PaymentMethodModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodModal.vue?vue&type=script&lang=js"

import "./PaymentMethodModal.vue?vue&type=style&index=0&id=ba7cdc82&lang=scss"
script.render = render

export default script